"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateJson = validateJson;
/**
 * Validate content is json.
 * @param json Json string to validate
 * @returns Error or undefined
 */
function validateJson(json) {
    try {
        // quick check on data.
        JSON.parse(json);
    }
    catch (e) {
        if (e instanceof SyntaxError) {
            const message = "" + e.message;
            try {
                return {
                    message: message.substring(0, message.lastIndexOf("at")).trim(),
                    position: parseInt(e.message.substring(e.message.lastIndexOf(" ")).trim()),
                };
            }
            catch (_a) {
                // ignore.
            }
        }
    }
    return undefined;
}
//# sourceMappingURL=utils.js.map